const ecpRoutes = [
  {
    path: "ecp",
    meta: {
      title: "GQF 교육프로그램",
      titleEn: "Extra Curriculum",
    },
    children: [
      {
        path: "category", // ecp/category
        meta: {
          title: "GQF 교육프로그램 카테고리",
          titleEn: "Extra Curriculum Category Management",
          isDynamic: true,
          menuCd: "ECP_CATEGORY",
        },
        component: () => import("@/views/ecp/category/EcpCategoryIndex.vue"),
      },
      {
        path: "approve", // ecp/approve
        children: [
          {
            path: "", // ecp/approve
            meta: {
              title: "GQF 교육프로그램 승인",
              titleEn: "Extra Curriculum Approve",
              isDynamic: true,
              menuCd: "ECP_APPROVE",
            },
            component: () => import("@/views/ecp/approve/EcpApproveIndex.vue"),
          },
          {
            path: "detail", // ecp/approve/detail
            meta: {
              title: "GQF 교육프로그램 승인 상세",
              titleEn: "Extra Curriculum Approve Detail",
              isDynamic: true,
              menuCd: "ECP_APPROVE",
            },
            component: () => import("@/views/ecp/cmmn/EcpDetail.vue"),
          },
        ],
      },
      {
        path: "operate", // ecp/operate
        children: [
          {
            path: "", // ecp/operate
            meta: {
              title: "GQF 교육프로그램 운영",
              titleEn: "Extra Curriculum Operate",
              isDynamic: true,
              menuCd: "ADM_ECP_OPERATE",
            },
            component: () => import("@/views/ecp/operate/EcpOperateIndex.vue"),
          },
          {
            path: "detail", // ecp/operate/detail
            meta: {
              title: "GQF 교육프로그램 운영 상세",
              titleEn: "Extra Curriculum Operate Detail",
              isDynamic: true,
              menuCd: "ADM_ECP_OPERATE",
            },
            component: () => import("@/views/ecp/cmmn/EcpDetail.vue"),
          },
          {
            path: "apply", // ecp/operate/apply
            meta: {
              title: "GQF 교육프로그램 인원 관리",
              titleEn: "Extra Curriculum Operate Apply",
              isDynamic: true,
              menuCd: "ADM_ECP_OPERATE",
            },
            //@gqf
            component: () => import("@/views/ecp/operate/EcpApplyIndex-inha.vue"),
          },
        ],
      },
      {
        path: "external-user", // ecp/external-user
        children: [
          {
            path: "", // ecp/external-user
            meta: {
              title: "외부강사",
              titleEn: "",
              isDynamic: true,
              menuCd: "ECP_EXTERNAL_USER",
            },
            component: () => import("@/views/ecp/external-user/EcpExternalUserIndex.vue"),
          },
          {
            path: "detail", // ecp/external-user/detail
            meta: {
              title: "외부강사 등록/수정",
              titleEn: "",
              isDynamic: true,
              menuCd: "ECP_EXTERNAL_USER",
            },
            component: () => import("@/views/ecp/external-user/EcpExternalUserDetail.vue"),
          },
        ],
      },
      {
        path: "cqi", // ecp/cqi
        children: [
          {
            path: "setting", // ecp/cqi/setting
            meta: {
              title: "GQF 교육프로그램 CQI",
              titleEn: "Setting up extracurricular CQI times",
              isDynamic: true,
              menuCd: "ECP_CQI",
            },
            component: () => import("@/views/ecp/cqi/CqiSetting.vue"),
          },
          {
            path: "dept",
            children: [
              {
                path: "", // ecp/cqi/dept
                meta: {
                  title: "부서CQI",
                  titleEn: "CQI Department",
                  isDynamic: true,
                  menuCd: "ECP_CQI",
                },
                component: () => import("@/views/ecp/cqi/dept/CqiDept.vue"),
              },
              {
                path: "register", // ecp/cqi/dept/register
                meta: {
                  title: "부서CQI 등록",
                  titleEn: "Register CQI Department",
                  isDynamic: true,
                  menuCd: "ECP_CQI",
                },
                component: () => import("@/views/ecp/cqi/dept/RegCqiDept.vue"),
              },
            ],
          },
          {
            path: "univ",
            children: [
              {
                path: "", // ecp/cqi/univ
                meta: {
                  title: "대학CQI",
                  titleEn: "CQI University",
                  isDynamic: true,
                  menuCd: "ECP_CQI",
                },
                component: () => import("@/views/ecp/cqi/univ/CqiUniv.vue"),
              },
              {
                path: "arrangeAndRetrieve", // ecp/cqi/univ/arrangeAndRetrieve
                meta: {
                  title: "대학CQI 배정 및 조회",
                  titleEn: "Arrange And Retrieve Content CQI University",
                  isDynamic: true,
                  menuCd: "ECP_CQI",
                },
                component: () => import("@/views/ecp/cqi/univ/ArrRetCqiUniv.vue"),
              },
              {
                path: "answer", // ecp/cqi/univ/answer
                meta: {
                  title: "대학CQI 답변",
                  titleEn: "Answer CQI University",
                  isDynamic: true,
                  menuCd: "ECP_CQI",
                },
                component: () => import("@/views/ecp/cqi/univ/AnsCqiUniv.vue"),
              },
              {
                path: "answer/register", // ecp/cqi/univ/answer/register
                meta: {
                  title: "대학CQI답변등록",
                  titleEn: "Register Answer CQI University",
                  isDynamic: true,
                  menuCd: "ECP_CQI",
                },
                component: () => import("@/views/ecp/cqi/univ/RegAnsCqiUniv.vue"),
              },
            ],
          },
        ],
      },
    ],
  },
];
export default ecpRoutes;
